const WORDS = [
  "DOVE NASCE LA VISIBILITÀ", "MARKETING A 360°", "SOCIAL-FIRST", "STRATEGIA",
  "CONTENUTI", "BRANDING", "VIDEO", "CRESCITA",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`whitespace-nowrap font-display text-2xl font-black tracking-tight sm:text-3xl lg:text-4xl ${i % 2 === 0 ? "text-navy" : "text-outline-light"}`}>
          {w}
        </span>
        <svg viewBox="0 0 24 24" className="mx-8 h-4 w-4 text-brand-blue" fill="currentColor" aria-hidden="true">
          <circle cx="12" cy="12" r="4" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-slate-200 bg-white py-5" aria-hidden="true">
    <div className="marquee-track flex w-max will-change-transform">
      <Row />
      <Row />
    </div>
  </div>
);
